import request from "@/utils/request";

// 审核评论
export function auditReview(params) {
  return request({
    url: "/reviews/review",
    method: "get",
    params
  });
}

// 新增评论回复
export function addReviewReply(params) {
  return request({
    url: "/reviews/addReviewReply",
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json"
    }
  });
}

// 新增订单评论
export function addOrderReviews(params) {
  return request({
    url: "/reviews/addOrderReviews",
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json"
    }
  });
}

// 查询评论回复列表
export function getAdminReviewRepliesList(params) {
  return request({
    url: "/reviews/getAdminReviewRepliesList",
    method: "get",
    params
  });
}
// 查询商品评论列表
export function getAdminGoodsReviewsList(params) {
  return request({
    url: "/reviews/getAdminGoodsReviewsList",
    method: "get",
    params
  });
}
// 删除评论
export function deleteReview(params) {
  return request({
    url: "/reviews/deleteReview",
    method: "get",
    params
  });
}
// 删除评论回复
export function deleteReviewReply(params) {
  return request({
    url: "/reviews/deleteReviewReplies",
    method: "get",
    params
  });
}
